import { AccountInfo } from '@azure/msal-common';

export enum CCETRoles {
  admin = 'CCET.Administrator',
}

export class CCETAccountInfo implements AccountInfo {
  homeAccountId: string;
  environment: string;
  tenantId: string;
  username: string;
  localAccountId: string;
  name?: string;
  idTokenClaims?: Partial<{ roles: any[]; [key: string]: any }>;

  constructor(account: Partial<CCETAccountInfo>) {
    this.homeAccountId = account.homeAccountId || '';
    this.environment = account.environment || '';
    this.tenantId = account.tenantId || '';
    this.username = account.username || '';
    this.localAccountId = account.localAccountId || '';
    this.name = account.name || '';
    this.idTokenClaims = account.idTokenClaims || {};
  }
}
